const { useEffect } = require('react')

const useCrispChat = (crsipId) => {
  useEffect(() => {
    window.CRISP_WEBSITE_ID = crsipId

    window.$crisp = []
    ;(function () {
      const d = document
      const s = d.createElement('script')
      s.src = 'https://client.crisp.chat/l.js'
      s.async = 1
      d.getElementsByTagName('head')[0].appendChild(s)
    })()
  }, [crsipId])
}

export default useCrispChat
